/**
 * 앱 공통 상수
 */

/** 딥링크 URL scheme (capacitor.config.ts appId와 동일) */
export const DEEPLINK_SCHEME = "com.koreadcc.ict";

/** 웹사이트 URL (환경변수 또는 기본값) */
export const WEB_URL = (import.meta.env.VITE_WEB_URL || "https://ict.koreadcc.com").replace(
  /\/$/,
  ""
);
